import React, {FC, useEffect} from 'react';

import {Modal, zIndex} from '@optimaxdev/design-system';

import {useSelector} from 'react-redux';

import {updateUrlParams} from 'libs/url/url';

import {getCartShareId} from '../../store/selectors/quoteInfo/quoteInfo';

import s from './cartSavePopup.scss';

export type PropsType = {
    isVisible: boolean;
    closePopup: () => void;
};

/**
 * Class of popup with saved cart id
 */
export const CartSavePopup: FC<PropsType> = props => {
    const {closePopup, isVisible} = props;
    const shareId = useSelector(getCartShareId);

    useEffect(() => {
        if (isVisible && shareId) {
            updateUrlParams({token: [shareId]});
        }
    }, [shareId, isVisible]);

    return (
        <Modal isOpen={isVisible} onRequestClose={closePopup} overlay="dark" zIndex={zIndex.popup}>
            <div className={s.popup} data-test-name="cartSavePopup">
                <p>Copy the following number:</p>
                <p className={s.cartID} data-test-name="cartId">
                    {shareId}
                </p>
                <p>So that our customer service can help you quicker.</p>
                <button
                    className={s.button}
                    data-test-name="okButton"
                    onClick={closePopup}
                    type="button"
                >
                    Ok
                </button>
            </div>
        </Modal>
    );
};
